<template>
  <v-container fluid>
    <v-card flat class="exams">
      <v-card-title>
        {{ currentProgramme ? currentProgramme.programme : "" }}
        <span class="ml-2">Units</span>
        <v-spacer />
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          clearable
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :items-per-page="5"
          :headers="headers"
          :items="programme"
          :search="search"
        >
          <template v-slot:[`item.ID`]="{ index }">
            <span>{{ index + 1 }}</span>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn small color="primary" @click="downloadNotes(item.code)">
              <v-icon left> mdi-download </v-icon>
              Download
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { helper } from "@/packages/dashboard/utils";
import FileMixin from "../../dashboard/mixin/FileMixin";

export default {
  name: "UnitNotes",
  mixins: [FileMixin],
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Exam/getUnits");
    });
  },
  data: () => ({
    search: "",
    headers: [
      { text: "#S/N", value: "ID" },
      { text: "Unit Code", value: "code" },
      { text: "Unit", value: "description" },
      { text: "Action", value: "action" },
    ],
  }),
  computed: {
    currentProgramme() {
      return this.$store.getters["Dashboard/currentProgramme"][0];
    },
    setupProgrammes() {
      return this.$store.getters["Exam/studentExamGetter"]("setupProgrammes");
    },
    programme() {
      const prog = this.setupProgrammes
        ? this.setupProgrammes
            .filter((item) => item.code === this.currentProgramme.programme)
            .shift()
        : [];
      const stages = prog ? prog.programmeStages.shift() : [];
      return stages
        ? stages.programmeUnits
          ? stages.programmeUnits.filter((el) => el.hasNotes)
          : []
        : [];
    },
    notes() {
      return this.$store.getters["Exam/studentExamGetter"]("programmeNotes");
    },
  },
  methods: {
    formatDate(date) {
      return helper.getDateFormat(date);
    },
    formatTime(time) {
      return helper.getTimeFormat(time);
    },
    downloadNotes(unitCode) {
      this.$store.dispatch("Exam/getProgrammeNotes", unitCode);
    },
  },
  watch: {
    notes() {
      this.downloadLink(this.notes);
    },
  },
};
</script>
<style scoped>
@import url("../styles/exam.css");
</style>
